module.exports = __webpack_public_path__ + "static/Frogsong5-a45f0e7e1ee30dffd83810b396d1054e.png";